export enum OpenPageConfigClose {
  noClose,
  close
}

export type LinkPluginFunc = (link: string) => Promise<string> | string;

export interface OpenPageConfig {
  close?: OpenPageConfigClose,  // 是否关闭当前页面view，在客户端场景参数生效
  linkHandlePlugin?: LinkPluginFunc[],  // (string)=>string的方法数组，业务自行处理链接可调整参数
  videoFrom?: number, // 视频客户端生效，渠道号统计参数from的值，默认爱玩30158
  h5ForceOpenUrl?: boolean, // 强制ios视频客户端的h5使用openUrl方法，关闭工具里的自动转换伪协议功能
}
